<template>
  <div>
    <Header />

    <div class="bg-light">
      <div class="container">
        <div class="section-header-breadcrumb">
          <h2 class="title-page">Contactez-nous</h2>
          <a href="#">Accueil</a> <i class="ti ti-angle-right"></i>
          <span>Contactez-nous</span>
        </div>

        <div class="row justify-content-center mt-5">
          <div class="col-lg-6">
            <h2 class="h2-title text-center">Contactez-nous</h2>
            <p class="text-center font-16">Besoin d’une information ? <br />Effectuez votre demande en ligne.</p>
          </div>
        </div>

        <div class="row mt-3 align-items-center justify-content-center">
          <div class="col-lg-9">
            <div class="bg-white align-items-center round-10 p-4 d-flex justify-content-center gap-5">
              <div v-if="services.length > 0">
                <div
                  v-for="service in services.filter(s => s.titre === 'Service client')"
                  :key="service.id"
                  class="d-flex justify-content-center gap-5"
                >
                  <p class="mb-0 font-18">{{ service.titre }}</p>
                  <p class="mb-0 font-18">
                    <img :src="phone" /><span class="ps-3">{{ service.telephone }}</span>
                  </p>
                  <p class="mb-0 font-18">
                    <img :src="mail" /><span class="ps-3">{{ service.email }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-9 mt-5 mb-5">
            <div class="box-contact bg-white border-0 p-5 mb-5">
              <h4 class="text-center font-bold font-25 blue-color">Formulaire Contact</h4>
              <p class="text-center dark-color-1">
                <i>*Champs Obligatoires</i>
              </p>

              <div class="row">
                <div class="col-lg-6">
                  <div class="form-input">
                    <input v-model="form.nom" type="text" class="form-control" placeholder="Nom*" required />
                    <span v-if="errorName" class="error-message mb-4">{{ errorName }}</span>
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-input">
                    <input v-model="form.email" type="email" class="form-control" placeholder="Email*" required />
                    <span v-if="errorEmail" class="error-message mb-4">{{ errorEmail }}</span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12">
                  <div class="form-input">
                    <select v-model="form.objet" class="form-control">
                      <option value="">Objet</option>
                      <option v-for="obj in objets" :key="obj.id" :value="obj.id">
                        {{ obj.titre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div v-if="form.objet == '1'">
                <div class="form-input">
                  <input
                    v-model="form.numcmd"
                    type="text"
                    class="form-control"
                    placeholder="Numéro de commande"
                    required
                  />
                </div>

                <div class="check-element mt-4">
                  <h4 class="font-16 blue-color mb-3">Sélectionnez les éléments que vous souhaitez modifier :</h4>

                  <div class="d-flex gap-4">
                    <div class="custom-checkbox">
                      <label>
                        <input type="checkbox" v-model="showFacture" />
                        Adresse de facturation</label
                      >
                    </div>
                    <div class="custom-checkbox">
                      <label>
                        <input type="checkbox" v-model="showAdresse" />
                        Adresse de livraison</label
                      >
                    </div>
                    <div class="custom-checkbox">
                      <label>
                        <input type="checkbox" v-model="showEmail" />
                        Email</label
                      >
                    </div>
                    <div class="custom-checkbox">
                      <label>
                        <input type="checkbox" v-model="showPhone" />
                        Téléphone fixe</label
                      >
                    </div>
                    <div class="custom-checkbox">
                      <label>
                        <input type="checkbox" v-model="showNom" />
                        Nom</label
                      >
                    </div>

                    <div class="custom-checkbox">
                      <label>
                        <input type="checkbox" v-model="showPrenom" />
                        Prénom</label
                      >
                    </div>
                  </div>
                </div>
                <div class="form-block mb-3">
                  <div v-if="showFacture">
                    <h5 class="blue-color font-bold font-16 mt-5 mb-4">Adresse de facturation</h5>

                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">Adresse* :</label>
                          <input type="text" class="form-control" v-model="form.adresse" placeholder="" />
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">Complément d’adresse :</label>
                          <input type="text" class="form-control" v-model="form.complement1" placeholder="" />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">Complément d’adresse 2 :</label>
                          <input type="text" class="form-control" v-model="form.complement2" placeholder="" />
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">Code postal :</label>
                          <input type="text" class="form-control" v-model="form.codePostal" placeholder="" v-only-digits />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">Ville :</label>
                          <input type="text" class="form-control" v-model="form.ville" placeholder="" />
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">Pays :</label>
                          <input type="text" class="form-control" v-model="form.pays" placeholder="" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="showAdresse">
                    <h5 class="blue-color font-bold font-16 mt-5 mb-4">Adresse de livraison</h5>

                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">Adresse* :</label>
                          <input type="text" class="form-control" v-model="form.adresse" placeholder="" />
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">Complément d’adresse :</label>
                          <input type="text" class="form-control" v-model="form.complement1" placeholder="" />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">Complément d’adresse 2 :</label>
                          <input type="text" class="form-control" v-model="form.complement2" placeholder="" />
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">Code postal :</label>
                          <input type="text" class="form-control" v-model="form.codePostal" placeholder="" v-only-digits />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">Ville :</label>
                          <input type="text" class="form-control" v-model="form.ville" placeholder="" />
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">Pays :</label>
                          <input type="text" class="form-control" v-model="form.pays" placeholder="" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="showEmail">
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">Email* :</label>
                          <input type="email" class="form-control" v-model="form.email" placeholder="" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="showPhone">
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">Phone* :</label>
                          <input type="tel" class="form-control" v-model="form.phone" placeholder="" v-only-digits />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="showNom">
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">Nom* :</label>
                          <input type="tel" class="form-control" v-model="form.nom" placeholder="" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="showPrenom">
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">Prenom* :</label>
                          <input type="tel" class="form-control" v-model="form.prenom" placeholder="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="form.objet == '3'">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-input">
                      <label class="label-control">Phone* :</label>
                      <input type="tel" class="form-control" v-model="form.phone" placeholder="" v-only-digits />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-input">
                    <textarea v-model="form.message" class="form-control" rows="8" placeholder="Message"></textarea>
                    <span v-if="errorMessage" class="error-message mb-4">{{ errorMessage }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-center">
              <button
                class="btn btn-orange w-25"
                ref="sendButton"
                @click.prevent="EnvoiContact"
                v-html="$sanitize.sanitizeI18nContent(buttonContent)"
              ></button>
            </div>

            <div v-if="successEnvoiMessage" class="alert alert-success mt-4 w-50 content-centered">
              <span class="success-message">{{ successEnvoiMessage }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="pt-5 pb-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <h2 class="font-32 blue-color font-bold text-center">
              Les produits recommandés par votre vétérinaire, depuis chez vous
            </h2>

            <div class="row mt-5 justify-content-center align-items-center">
              <div class="col-lg-4">
                <div class="d-flex flex-column justify-content-center gap-3 align-items-center">
                  <img :src="support" class="w-30" />
                  <p class="text-center font-bold blue-color">Un service client à votre écoute</p>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="d-flex flex-column justify-content-center gap-3 align-items-center">
                  <img :src="pays" class="w-30" />
                  <p class="text-center font-bold blue-color">100% made in France</p>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="d-flex flex-column justify-content-center gap-3 align-items-center">
                  <img :src="delivery" class="w-30" />
                  <p class="text-center font-bold blue-color">Livraison sous 48 à 72h</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="question-list bg-light-1">
      <div class="container">
        <div class="content col-sm-12 col-md-12 col-lg-12">
          <Question />
        </div>
      </div>
    </div>

    <div class="pt-5 pb-5">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-5">
            <h2 class="font-32 blue-color font-bold">Restez informé des dernières promotions et nouveautés !</h2>
            <p>
              Inscrivez-vous à notre newsletter pour recevoir des offres exclusives et des conseils professionnels
              adaptés à votre clinique.
            </p>
          </div>

          <div class="col-lg-5 offset-lg-2">
            <form>
              <div class="form-input email-input">
                <input type="email" placeholder="email" class="form-control" />
                <a href="" class="btn btn-orange btn-circle"><img :src="send" /></a>
              </div>
              <p>êtes-vous propriétaire d’un :</p>

              <div class="d-flex gap-3">
                <label
                  v-for="option in options"
                  :key="option"
                  :class="['check-button', { active: selected.includes(option) }]"
                >
                  <input type="checkbox" :value="option" v-model="selected" hidden />
                  <span class="label-text">{{ option }}</span>
                  <span class="check-icon" v-if="selected.includes(option)"><i class="ti ti-check-box ps-2"></i></span>
                </label>
              </div>
              <p class="blue-color mt-3">
                Nous respectons votre confidentialité.<br />
                Désinscription à tout moment.
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
  import Header from "@/components/Header.vue";
  import Footer from "@/components/Footer.vue";
  import phone from "@/assets/images/phone.svg";
  import user from "@/assets/images/user.svg";
  import mail from "@/assets/images/envelope.svg";
  import { useRegisterStore } from "@/stores/register";
  import { useContactsStore } from "@/stores/contactStore";
  import { SendContact } from "@/api/auth";
  import Question from "@/components/Question.vue";
  import support from "@/assets/images/support.svg";
  import pays from "@/assets/images/pays.svg";
  import delivery from "@/assets/images/delivery.svg";
  import send from "@/assets/images/send.svg";
  import { ref } from "vue";
  const showFacture = ref(false);
  const showAdresse = ref(false);
  const showEmail = ref(false);
  const showPhone = ref(false);
  const showNom = ref(false);
  const showPrenom = ref(false);
  export default {
    components: {
      Header,
      Footer,
      Question,
    },
    data() {
      showFacture;
      showAdresse;
      showEmail;
      showPhone;
      showPrenom;
      showNom;
      return {
        options: ["chien", "Chat", "cheval"],
        selected: [],
        showFacture,
        showAdresse,
        showEmail,
        showPhone,
        showPrenom,
        showNom,
        phone,
        support,
        pays,
        send,
        delivery,
        user,
        mail,
        serviceStore: null,
        veterinaire: {},
        form: {
          nom: "",
          email: "",
          objet: "",
          message: "",
        },
        isLoading: false,
        errorName: "",
        errorEmail: "",
        errorMessage: "",
        canStore: true,
        successEnvoiMessage: "",
        errorEnvoiMessage: "",
        buttonContent: "Envoyer",
      };
    },
    computed: {
      services() {
        return useContactsStore()
          .Services.slice()
          .sort((a, b) => a.id - b.id);
      },
      objets() {
        return useContactsStore()
          .Objets.slice()
          .sort((a, b) => a.id - b.id);
      },
      loading() {
        return useContactsStore().loading;
      },
    },
    created() {
      const store = useRegisterStore();
      this.veterinaire = store.VeterinaireInfo;
      this.contactStore = useContactsStore();
      this.contactStore.fetchServices_Delegues();
      this.contactStore.fetchObjets();
    },
    methods: {
      EnvoiContact() {
        this.errorName = "";
        this.errorEmail = "";
        this.errorMessage = "";
        this.canStore = true;
        this.isLoading = true;
        this.buttonContent =
          '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Envoi en cours ...';
        this.CheckValidate();
        if (this.canStore) {
          this.form.channel = "/api/v2/shop/channels/supplyvet";
          this.form.objetInfo = "/api/v2/shop/form-contacts-objets/" + this.form.objet;
          SendContact(this.form)
            .then(res => {
              if (res.data && res.data.id) {
                this.form = {
                  nom: "",
                  email: "",
                  objet: "",
                  message: "",
                };
                this.successEnvoiMessage = "Votre message à été envoyé avec succeé";
                setTimeout(() => {
                  this.successEnvoiMessage = "";
                }, 5000);
              }
              this.buttonContent = "Envoyer";
              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
              this.buttonContent = "Envoyer";
            });
        }
      },
      CheckValidate() {
        if (this.form.nom == "") {
          this.errorName = "Le champ nom est obligatoire";
          this.canStore = false;
        }

        if (this.form.email == "") {
          this.errorEmail = "Le champ email est obligatoire";
          this.canStore = false;
        } else {
          const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!regex.test(this.form.email)) {
            this.errorEmail = "Format Email invalide";
            this.canStore = false;
          }
        }

        if (this.form.message == "") {
          this.errorMessage = "Le champ message est obligatoire";
          this.canStore = false;
        }

        if (!this.canStore) {
          this.isLoading = false;
          this.buttonContent = "Envoyer";
        }
      },
    },
  };
</script>
